import { useEECEvents } from 'analytics/hooks/useEECEvents/useEECEvents'
import { useAnalyticsImpressionsStore } from 'analytics/stores/analyticsImpressions'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { ProductLocations } from 'product/types/ProductLocations'
import { useCallback, useMemo } from 'react'
import { PageType } from 'types/analytics'

export const useAnalyticsImpressions = () => {
	const addImpression = useAnalyticsImpressionsStore(
		(state) => state.addImpression
	)
	const resetImpressions = useAnalyticsImpressionsStore(
		(state) => state.resetImpressions
	)

	const { sendViewItemList } = useEECEvents()
	const { pageType } = useMasterData()

	const flushImpressions = useCallback(() => {
		// The current impressions are fetched directly from the store
		// to avoid unnecessary re-renders when impressions change
		const impressions = structuredClone(
			useAnalyticsImpressionsStore.getState().impressions
		)

		// If there are no impressions or the session ID is not available, do nothing
		if (impressions.length === 0 || !window.analytics?.sessionId) {
			return
		}

		resetImpressions()

		sendViewItemList({
			items: impressions,
			listId:
				pageType === PageType.PDP
					? ProductLocations.CrossSellingsPDP
					: undefined,
		})
	}, [resetImpressions, sendViewItemList, pageType])

	return useMemo(
		() => ({ addImpression, flushImpressions }),
		[addImpression, flushImpressions]
	)
}
